import { Middleware } from '@nuxt/types'

const productFilter: Middleware = ({ store }) => {
  if (store.state.productFiltersOpen) {
    store.commit('SET_FILTERING_OPEN', false)
  }
}

export default productFilter
